import { createContext, useState } from "react";

export const DependentHistoryContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    let emptyDependentHistory = {};

    const [dependentHistories, setDependentHistories] = useState(emptyDependentHistory);
    const [dependentHistory, setDependentHistory] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [dependentHistoryDialog, setDependentHistoryDialog] = useState(false);
    const [dependentHistoryInfoDialog, setDependentHistoryInfoDialog] = useState(false);

    const [dependents, setDependents] = useState([]);
    const [dependent, setDependent] = useState({});

    const resetNotificationLog = () => {
        setDependentHistories(emptyDependentHistory);
    };

    // Make the context object:
    const dependentHistoryContext = {
        dependentHistories,
        resetNotificationLog,
        setDependentHistories,
        dependentHistory,
        setDependentHistory,
        submitted,
        setSubmitted,
        dependentHistoryDialog,
        setDependentHistoryDialog,
        dependents,
        setDependents,
        dependent,
        setDependent,
        dependentHistoryInfoDialog,
        setDependentHistoryInfoDialog,
    };

    // pass the value in provider and return
    return <DependentHistoryContext.Provider value={dependentHistoryContext}>{children}</DependentHistoryContext.Provider>;
};

export const { Consumer } = DependentHistoryContext;
